import { useGlobalQueries } from '@/hooks/use-global-queries';
import { removeEnclosingSlashes } from '@/utils/strings';
import { Link, useLocation } from 'react-router-dom';
import defaultLogoUrl from '@/assets/logos/resurs_logo_rgb_black.svg';
import { Login } from '../login';
import { useLocalization } from '@/hooks/use-localization';
import { useNavMenus } from '@/hooks/use-nav-menus';
import { MarketType } from '@/queries/page';
import clsx from 'clsx';

type HeaderProps = {
    setShowMenu: (show: boolean) => void;
};

export const Header = ({ setShowMenu }: HeaderProps) => {
    const { getMarketType } = useGlobalQueries();
    const { pathname } = useLocation();
    const { localize } = useLocalization();
    const { headerSettings } = useNavMenus();

    const marketType = getMarketType();
    const marketLogos = headerSettings.data?.market_logos;
    const marketLogoLinks = headerSettings.data?.market_logo_links;
    const marketLogo = marketType && marketType !== 'cluster' ? marketLogos?.[marketType as Exclude<MarketType, 'cluster'>] : false;
    const marketLogoLink = marketType && marketType !== 'cluster' ? marketLogoLinks?.[marketType as Exclude<MarketType, 'cluster'>] : false;

    const logoUrl = marketLogo && marketLogo.url ? marketLogo.url : defaultLogoUrl;
    const logoAlt = marketLogo && marketLogo.alt ? marketLogo.alt : 'Resurs Bank logo';
    const isCustomLogo = !!(marketLogo && marketLogo.url);

    const getHomeLink = () => {
        if (marketLogoLink && marketLogoLink.url) {
            return marketLogoLink.url;
        }

        if (getMarketType() !== 'cluster') {
            return '/';
        }

        return removeEnclosingSlashes(pathname).split('/')[0] ?? '';
    };
    return (
        <div className="r-flex r-h-24 r-items-center r-justify-between r-px-4 md:r-hidden">
            <div className="r-max-w-[160px]">
                <Link to={getHomeLink()}>
                    <img
                        className={clsx(isCustomLogo ? 'r-max-w-[170px] sm:r-max-w-[200px]' : 'r-max-w-[160px]')}
                        src={logoUrl}
                        alt={logoAlt}
                        width={190}
                        height={29}
                    />
                </Link>
            </div>
            <div className="r-flex r-gap-4">
                <Login />
                <div className="r-flex r-items-center r-space-x-6">
                    <button onClick={() => setShowMenu(true)} aria-label={localize('open-menu')}>
                        <img src="/assets/icons/hamburger-2.svg" alt="" className="r-h-8 r-w-8" width={32} height={32} />
                    </button>
                </div>
            </div>
        </div>
    );
};
